module.exports = __webpack_public_path__ + "img/product-tutorial-1.80817898.png";